import * as getTypes from '../get-types'
import * as actionTypes from '../action-types'
import * as mutationTypes from '../mutation-types'
import { RedeemedItem } from '@/store/classes/redeemed-item'
import { RedemptionApi } from '@/cowboy/redemption/RedemptionApi'

const state = {
  items: [],
  referenceLineItemId: null,
  noMoreItems: false
}

const getters = {
  [getTypes.GET_REDEMPTION_HISTORY]: state => state.items,
  [getTypes.GET_NO_MORE_ITEMS]: state => state.noMoreItems
}

const actions = {
  async [actionTypes.FETCH_REDEMPTION_HISTORY] (
    { getters, commit, state },
    countIn
  ) {
    const count = countIn || 10
    let after
    if (state.referenceLineItemId) {
      after = state.referenceLineItemId
    }
    const redemptionHistories = (await RedemptionApi.fetchRedemptionHistory(count, after)).map(history => history.toJSON())
    if (redemptionHistories.length) {
      const itemsToAdd = []
      redemptionHistories.forEach(item => itemsToAdd.push(new RedeemedItem(item)))
      const { referenceLineItemId } = itemsToAdd[0] // List is desc, last reward should be first item.
      commit(mutationTypes.SET_REFERENCE_LINE_ITEM_ID, referenceLineItemId)
      commit(mutationTypes.ADD_REDEMPTION_HISTORY_ITEMS, itemsToAdd)
    } else {
      commit(mutationTypes.SET_NO_MORE_ITEMS, true)
    }
  },
  async [actionTypes.RESEND_REWARD] (_, referenceLineItemId) {
    await RedemptionApi.resendReward(referenceLineItemId)
  },
  [actionTypes.RESET_REDEMPTION_HISTORY] ({ commit }) {
    commit(mutationTypes.SET_NO_MORE_ITEMS, false)
  }
}

const mutations = {
  [mutationTypes.ADD_REDEMPTION_HISTORY_ITEMS] (state, items) {
    state.items = items.concat(state.items) // We want to add the new items to the front of the list.
  },
  [mutationTypes.SET_REFERENCE_LINE_ITEM_ID] (state, referenceLineItemId) {
    state.referenceLineItemId = referenceLineItemId
  },
  [mutationTypes.SET_NO_MORE_ITEMS] (state, noMoreItems) {
    state.noMoreItems = noMoreItems
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
